module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/841a85ee6d1c7e2574d87175354b0321.svg";